'use strict';

exports.__esModule = true;
exports.default = undefined;

var _cardsContainer = require('./cards-container.scss');

var _cardsContainer2 = _interopRequireDefault(_cardsContainer);

var _constants = require('../constants');

var _domUpdateDelay = require('../utils/dom-update-delay');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CardsContainer = function () {
  function CardsContainer(_ref) {
    var cardsConfig = _ref.cardsConfig;

    _classCallCheck(this, CardsContainer);

    this.cardsConfig = cardsConfig;
    this.initUI();
    this.handleConfigChange();
    this.cardsConfig.onChange(this.handleConfigChange, this);
  }

  CardsContainer.prototype.initUI = function initUI() {
    this.node = document.createElement('div');
    this.node.classList.add(_cardsContainer2.default.container);
    this.onControlsShown();
    this.enableAnimation();
  };

  CardsContainer.prototype.handleConfigChange = function handleConfigChange() {
    var _cardsConfig = this.cardsConfig,
        isPreviewMode = _cardsConfig.isPreviewMode,
        anchorPoint = _cardsConfig.anchorPoint;

    isPreviewMode ? this.enablePreviewMode() : this.disablePreviewMode();
    this.setAnchorPoint(anchorPoint);
  };

  CardsContainer.prototype.hide = function hide() {
    this.node.classList.add(_cardsContainer2.default.hidden);
  };

  CardsContainer.prototype.show = function show() {
    this.node.classList.remove(_cardsContainer2.default.hidden);
  };

  CardsContainer.prototype.enablePreviewMode = function enablePreviewMode() {
    this.node.classList.add('preview-mode');
  };

  CardsContainer.prototype.disablePreviewMode = function disablePreviewMode() {
    this.node.classList.remove('preview-mode');
  };

  CardsContainer.prototype.onControlsShown = function onControlsShown() {
    this.node.classList.add(_cardsContainer2.default['controls-showed']);
  };

  CardsContainer.prototype.onControlsHidden = function onControlsHidden() {
    this.node.classList.remove(_cardsContainer2.default['controls-showed']);
  };

  CardsContainer.prototype.setAnchorPoint = function setAnchorPoint(anchorPoint) {
    this.node.setAttribute('data-anchor-point', anchorPoint);
  };

  CardsContainer.prototype.enableAnimation = function enableAnimation() {
    this.node.classList.add('animated');
    return (0, _domUpdateDelay.waitForDomUpdate)();
  };

  CardsContainer.prototype.disableAnimation = function disableAnimation() {
    this.node.classList.remove('animated');
    return (0, _domUpdateDelay.waitForDomUpdate)();
  };

  CardsContainer.prototype.addCardNodes = function addCardNodes(cards) {
    var _this = this;

    cards.forEach(function (card) {
      return _this.node.appendChild(card.node);
    });
    return (0, _domUpdateDelay.waitForDomUpdate)();
  };

  CardsContainer.prototype.removeCardNodes = function removeCardNodes(cards) {
    var _this2 = this;

    cards.forEach(function (card) {
      return _this2.removeCardNode(card);
    });
  };

  CardsContainer.prototype.removeCardNode = function removeCardNode(card) {
    if (card.node.parentNode === this.node) {
      this.node.removeChild(card.node);
    }
  };

  CardsContainer.prototype.getSize = function getSize() {
    var orientation = this.cardsConfig.orientation;

    return orientation === _constants.ORIENTATIONS.HORIZONTAL ? this.node.offsetWidth : this.node.offsetHeight;
  };

  CardsContainer.prototype.destroy = function destroy() {
    if (this.node.parentNode) {
      this.node.parentNode.removeChild(this.node);
    }
    delete this.node;
  };

  return CardsContainer;
}();

exports.default = CardsContainer;